function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M240,90.232c-61.721-0.036-111.824,49.895-112,111.616c0.248,11.977,2.231,23.856,5.888,35.264 c5.395,12.141,11.637,23.887,18.68,35.152C168.944,300.8,193.68,343.952,193.68,360c0,4.418,3.582,8,8,8h76.64 c4.418,0,8-3.582,8-8c0-16.048,24.736-59.2,41.112-87.736c7.043-11.265,13.285-23.011,18.68-35.152 c3.657-11.408,5.64-23.286,5.888-35.264C351.824,140.127,301.721,90.196,240,90.232z M330.944,232 c-5.201,11.068-11.008,21.842-17.392,32.272C292.92,300.28,275.384,332,271.24,352H208.8c-4.144-20-21.68-51.72-42.312-87.696 c-6.399-10.44-12.219-21.224-17.432-32.304c-3.087-9.765-4.789-19.914-5.056-30.152c0-53.019,42.981-96,96-96s96,42.981,96,96 C335.733,212.086,334.031,222.235,330.944,232z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M278.936,460.632c-2.209-3.831-7.105-5.145-10.936-2.936L257.064,464h-34.128L212,457.696 c-3.831-2.209-8.727-0.895-10.936,2.936c-2.209,3.831-0.895,8.727,2.936,10.936l12.8,7.368c1.217,0.699,2.596,1.066,4,1.064h38.4 c1.404,0.002,2.783-0.365,4-1.064l12.8-7.368C279.831,469.359,281.145,464.463,278.936,460.632z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M279.96,384.8c-0.442-4.396-4.364-7.602-8.76-7.16v0l-64,6.4c-4.396,0.441-7.602,4.363-7.161,8.759 c0.41,4.089,3.852,7.201,7.961,7.201c0.264,0,0.528,0,0.8-0.04l64-6.4C277.196,393.118,280.402,389.196,279.96,384.8z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M279.96,408.8c-0.442-4.396-4.364-7.602-8.76-7.16v0l-64,6.4c-4.396,0.441-7.602,4.363-7.161,8.759 c0.41,4.089,3.852,7.201,7.961,7.201c0.264,0,0.528,0,0.8-0.04l64-6.4C277.196,417.118,280.402,413.196,279.96,408.8z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M279.96,432.8c-0.442-4.396-4.364-7.602-8.76-7.16v0l-64,6.4c-4.396,0.441-7.602,4.363-7.161,8.759 c0.41,4.089,3.852,7.201,7.961,7.201c0.264,0,0.528,0,0.8-0.04l64-6.4C277.196,441.118,280.402,437.196,279.96,432.8z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M240,0c-4.418,0-8,3.582-8,8v56c0,4.418,3.582,8,8,8s8-3.582,8-8V8C248,3.582,244.418,0,240,0z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M387.276,60.92c-3.07-3.178-8.134-3.266-11.312-0.196c-0.067,0.064-0.132,0.13-0.196,0.196l-39.6,39.6 c-3.178,3.07-3.266,8.134-0.196,11.312c3.07,3.178,8.134,3.266,11.312,0.196c0.067-0.064,0.132-0.13,0.196-0.196l39.6-39.6 C390.258,69.162,390.346,64.098,387.276,60.92z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M440,200h-56c-4.418,0-8,3.582-8,8s3.582,8,8,8h56c4.418,0,8-3.582,8-8S444.418,200,440,200z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M387.08,343.768l-39.6-39.6c-3.124-3.123-8.188-3.123-11.312,0c-3.123,3.124-3.123,8.188,0,11.312l39.6,39.6 c3.178,3.07,8.242,2.982,11.312-0.196C390.075,351.784,390.075,346.868,387.08,343.768z"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M143.636,304.168c-3.1-2.994-8.015-2.994-11.116,0l-39.6,39.6c-3.124,3.125-3.123,8.19,0.002,11.314 c1.5,1.499,3.534,2.342,5.654,2.342c2.122,0,4.156-0.844,5.656-2.344l39.6-39.6C146.901,312.302,146.814,307.237,143.636,304.168z "
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M96,200H40c-4.418,0-8,3.582-8,8s3.582,8,8,8h56c4.418,0,8-3.582,8-8S100.418,200,96,200z"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M143.832,100.52l-39.6-39.6c-3.069-3.178-8.134-3.266-11.312-0.197c-3.178,3.069-3.266,8.134-0.197,11.312 c0.064,0.067,0.13,0.132,0.197,0.197l39.6,39.6c1.496,1.506,3.533,2.35,5.656,2.344c4.418-0.001,7.999-3.583,7.998-8.002 C146.174,104.054,145.331,102.02,143.832,100.52z"
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M290.345,216.358c-1.591-0.488-3.295-0.468-4.873,0.058L240,231.568l-45.472-15.152 c-4.192-1.396-8.722,0.871-10.118,5.063c-0.526,1.579-0.546,3.282-0.058,4.873l32,104c1.299,4.224,5.776,6.595,10,5.296 c4.224-1.299,6.595-5.776,5.296-10l-27.432-89.144l33.256,11.08c1.64,0.552,3.416,0.552,5.056,0l33.256-11.08l-27.432,89.144 c-1.299,4.224,1.072,8.701,5.296,10c4.224,1.299,8.701-1.072,10-5.296l32-104C296.944,222.128,294.57,217.653,290.345,216.358z"
})));

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLightbulb = function SvgLightbulb(props) {
  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

export default __webpack_public_path__ + "static/media/lightbulb.f8e99da8.svg";
export { SvgLightbulb as ReactComponent };